import * as React from 'react';
import S from './NavigationDropdown.styles';
const NavigationDropdown = ({ image, items, title, url, visible, }) => {
    const [activeId, setActiveId] = React.useState('');
    return (React.createElement(S.Container, { "aria-hidden": !visible, initial: "hidden", animate: visible ? 'visible' : 'hidden', variants: {
            hidden: {
                opacity: 0,
                transitionEnd: {
                    display: 'none',
                },
            },
            visible: {
                display: 'grid',
                opacity: 1,
            },
        }, transition: {
            duration: 0.3,
            ease: 'easeOut',
            type: 'tween',
        } },
        React.createElement(S.ColumnLeft, null,
            React.createElement(S.Image, { alt: "", loading: "lazy", role: "presentation", src: image, initial: "hidden", animate: !activeId ? 'visible' : 'hidden', variants: {
                    hidden: {
                        opacity: 0,
                    },
                    visible: {
                        opacity: 1,
                    },
                }, transition: {
                    duration: 0.3,
                    ease: 'easeOut',
                    type: 'tween',
                } }),
            items.map((item) => (React.createElement(S.Image, { key: item.id, alt: "", loading: "lazy", role: "presentation", src: item.image, initial: "hidden", animate: item.id === activeId ? 'visible' : 'hidden', variants: {
                    hidden: {
                        opacity: 0,
                    },
                    visible: {
                        opacity: 1,
                    },
                } })))),
        React.createElement(S.ColumnRight, null,
            title && (React.createElement(S.Title, null,
                React.createElement(S.TitleLink, { href: url, tabIndex: visible ? 0 : -1 }, title))),
            React.createElement(S.List, null, items.map((child) => (React.createElement(S.Item, { key: child.id },
                React.createElement(S.Link, { href: child.url, tabIndex: visible ? 0 : -1, target: child.target, onMouseEnter: () => {
                        if (child.image) {
                            setActiveId(child.id);
                        }
                    }, onMouseLeave: () => {
                        setActiveId('');
                    } }, child.text))))))));
};
export default NavigationDropdown;
